import { createApi } from '@reduxjs/toolkit/query/react'
import { baseApi } from './services/utils'
import type { TDashboardWidgets } from './../components/DashboardWidgets/types'

export const controllersApi = createApi({
	reducerPath: 'fod',
	...baseApi('/'),
	tagTypes: ['Dashboard'],
	endpoints: build => ({
		getDashboardWidgets: build.query<TDashboardWidgets, void>({
			query: () => `/dashboards/main.php`,
			providesTags: ['Dashboard'],
		}),
	}),
})
export const { useGetDashboardWidgetsQuery } = controllersApi
